<template>
    <div class="main" v-loading.fullscreen="isLoad" element-loading-background="rgba(0, 0, 0,0)">
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>营销</el-breadcrumb-item>
            <el-breadcrumb-item>分销</el-breadcrumb-item>
            <el-breadcrumb-item>申请成为分销商</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="dis-flex">
            <div class="second-swaper">
                <second></second>
            </div>
            <div class="flex-box" style="overflow-x: hidden">
                <Card :bordered="false" dis-hover class="ivu-mt">
                    <Form ref="artFrom" :label-width="labelWidth" :label-position="labelPosition" @submit.native.prevent>
                        <Row type="flex">
                            <Col>
                                <FormItem label="分销商姓名：" label-for="order_no">
                                    <Input size="default" enter-button placeholder="分销商姓名" clearable v-model="tableFrom.real_name"/>
                                </FormItem>
                            </Col>
                            <Col>
                                <FormItem label="分销商手机号：" label-for="mobile">
                                    <Input size="default" enter-button placeholder="分销商手机号" clearable v-model="tableFrom.mobile"/>
                                </FormItem>
                            </Col>
                            <Col :xl="6" :lg="6" :md="12" :sm="12" :xs="24" class="search">
                                <FormItem>
                                    <Button type="primary" icon="ios-search" @click="userSearchs">搜索</Button>
                                    <Button class="ml20" type="success" @click="excelOut">导出</Button>
                                </FormItem>
                            </Col>
                        </Row>
                    </Form>
                    <Table class="mt25" :columns="columns" :data="tableData">
                        <template slot-scope="{ row, index }" slot="avatars">
                            <viewer>
                                <div class="tabBox_img">
                                    <img v-lazy="row.user.avatarUrl" />
                                </div>
                            </viewer>
                        </template>
                        <template slot-scope="{ row, index }" slot="referee">
                            <div class="" v-if="row.referee_id">{{row.referee ? row.referee.nick_name : ''}}({{row.referee ? row.referee.id : ''}})</div>
                            <div class="">平台</div>
                        </template>
                        <template slot-scope="{ row, index }" slot="apply_status">
                            <div class="" v-if="row.apply_status == 10">待审核</div>
                            <div class="" v-if="row.apply_status == 20">已通过</div>
                            <div class="" v-if="row.apply_status == 30">已驳回</div>
                        </template>
                        <template slot-scope="{ row, index }" slot="action">
                            <a @click="audit(row)" v-if="row.apply_status == 10">审核</a>
                        </template>
                    </Table>
                    <div class="acea-row row-right page">
                        <Page
                                :total="total"
                                :current="tableFrom.page"
                                show-elevator
                                show-total
                                @on-change="pageChange"
                                :page-size="tableFrom.limit"/>
                    </div>
                </Card>
            </div>
        </div>
        <audit-from
                ref="audit"
                @confirmFormData="confirmFormData"></audit-from>
    </div>
</template>

<script>
    import second from "../second.vue";
    import auditFrom from "./handle/audit.vue";
    export default {
        name: "index",
        components: { second, auditFrom },
        computed: {
            labelWidth () {
                return 75;
            },
            labelPosition () {
                return 'right';
            }
        },
        watch: {
            $route: function (e) {
                this.tableFrom.pid = e.query.id
                this.getList();
            }
        },
        data () {
            return {
                isLoad: false,
                columns: [
                    {
                        title: 'ID',
                        key: 'apply_id',
                        width: 60,
                    },
                    {
                        title: "头像",
                        slot: "avatars",
                        width: 60,
                    },
                    {
                        title: "真实姓名",
                        key: "real_name",
                        width: 120,
                    },
                    {
                        title: "手机号",
                        key: "mobile",
                        width: 120,
                    },
                    {
                        title: "推荐人",
                        align: 'center',
                        slot: "referee",
                        width: 120,
                    },
                    {
                        title: '审核状态',
                        slot: 'apply_status',
                        align: "center",
                        width: 90,
                    },
                    {
                        title: '添加时间',
                        key: 'create_time',
                        align: "center",
                        width: 180,
                    },
                    {
                        title: '操作',
                        slot: 'action',
                        align: "center",
                        minWidth: 100,
                    },
                ],
                tableFrom: {
                    page: 1,
                    limit: 15,
                    pid: this.$route.query.id ? this.$route.query.id : 0
                },
                total: 0,
                tableData: [],
                loading: false,
                apply_id: 0
            }
        },
        created() {
        },
        mounted () {
            this.getList();
        },
        methods: {
            pageChange(index) {
                this.tableFrom.page = index;
                this.getList();
            },
            audit(item) {
                console.log(item)
                this.apply_id = item.apply_id
                this.$refs.audit.modals = true;
            },
            // 列表
            getList () {
                this.loading = true;
                this.axios.post('/store/app.dealer.apply/list', this.tableFrom)
                .then(async (res) => {
                    if (res.code == 1) {
                        let data = res.data.list
                        this.tableData = data.data;
                        this.total = data.total;
                    }
                })
                .catch((res) => {
                    this.loading = false;
                });
            },
            // 表格搜索
            userSearchs() {
                this.tableFrom.page = 1;
                this.getList();
            },
            confirmFormData: function (formData) {
                this.axios.post('/store/app.dealer.apply/audit', Object.assign({
                    form: formData
                }, {
                    id: this.apply_id
                }))
                .then(async (res) => {
                    if (res.code == 1) {
                        this.$refs.audit.modals = false;
                        this.$Message.success(res.msg);
                        this.ids = []
                        this.getList();
                    } else {
                        this.$Message.error(res.msg);
                    }
                })
                .catch((res) => {
                    this.$Message.error(res.msg);
                });
            },
            excelOut() {
                if (this.isLoad) {
                    return false
                }

                this.isLoad = !this.isLoad
                setTimeout(function () {
                    this.isLoad = false
                }.bind(this), 100000);
                this.axios.post('/store/app.dealer.apply/export', this.item)
                    .then(res => {
                        this.isLoad = false
                        if (res.code == 1) {
                            import('@/vendor/Export2Excel.js').then(excel => {
                                var expCellName = res.data.expCellName
                                var tHeader = []
                                var filterVal = []
                                for (var i in expCellName) {
                                    tHeader.push(expCellName[i])
                                    filterVal.push(i)
                                }
                                const expTableData = res.data.expTableData
                                const data = this.formatJson(filterVal, expTableData)
                                var d = new Date()
                                var year = d.getFullYear()
                                var month = d.getMonth()
                                var date = d.getDate()
                                var hour = d.getHours()
                                var minute = d.getMinutes()
                                var second = d.getSeconds()
                                month = month < 10 ? '0' + month : month
                                date = date < 10 ? '0' + date : date
                                hour = hour < 10 ? '0' + hour : hour
                                minute = minute < 10 ? '0' + minute : minute
                                second = second < 10 ? '0' + second : second
                                excel.export_json_to_excel({
                                    header: tHeader,
                                    data,
                                    filename: '入驻审核导出_' + year + '' + month + '' + date + '' + hour + '' + minute + '' + second,
                                    autoWidth: this.autoWidth,
                                    bookType: this.bookType
                                })
                            })
                        } else {
                            this.$message({
                                message: res.msg,
                                type: 'error',
                                duration: 3 * 1000
                            })
                        }
                    })
            },
            formatJson (filterVal, jsonData) {
                return jsonData.map(v => filterVal.map(j => {
                    return v[j]
                }))
            },
        }
    }
</script>

<style scoped>

</style>
